import * as React from 'react';
import { useSelector } from 'react-redux';

import { getReviewIds } from '../../selectors/reviews';
import { ReviewsItemContainer } from '../ReviewsItem';
import { ReviewsList } from '../../components/ReviewsList';
import { EmptyListContainer } from '../EmptyListContainer';

export function ReviewsListContainer() {
  const ids = useSelector(getReviewIds);

  if (ids.length === 0) {
    return <EmptyListContainer />;
  }

  return (
    <ReviewsList>
      {ids.map(reviewId => (
        <ReviewsItemContainer key={reviewId} id={reviewId} />
      ))}
    </ReviewsList>
  );
}
